import { render, staticRenderFns } from "./BooksInspoPost.vue?vue&type=template&id=c41077de&scoped=true&"
import script from "./BooksInspoPost.vue?vue&type=script&lang=js&"
export * from "./BooksInspoPost.vue?vue&type=script&lang=js&"
import style0 from "./BooksInspoPost.vue?vue&type=style&index=0&id=c41077de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41077de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCarouselItem,VImg})
